import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { User } from '@core/entities/user'
import { IChecklistTemplateRole } from './IChecklistTemplateRole'
import { ChecklistTemplateRolePermissionType } from './types'
import { localizedStrings } from '@core/strings'

export class ChecklistTemplateRole extends Entity<IChecklistTemplateRole> {
  id: number
  templateVersionId: number
  name: string
  description?: string
  briefingText?: string
  permissions: Array<ChecklistTemplateRolePermissionType>
  groupIds?: Array<number>
  isBriefingAllowed?: boolean
  @Type(() => User)
  createdBy: User
  createdOn: string
  @Type(() => User)
  modifiedBy: User
  modifiedOn: string

  public static new(payload: unknown): ChecklistTemplateRole {
    const entity = plainToInstance(ChecklistTemplateRole, payload)

    return entity
  }

  public static getPermissionText(
    permission: ChecklistTemplateRolePermissionType,
  ): string {
    const permissionTextMap: Record<
      ChecklistTemplateRolePermissionType,
      string
    > = {
      ADD_PARTICIPANT: localizedStrings.addParticipants,
      BRIEF_SAME_ROLE: localizedStrings.briefSameRole,
    }

    return permissionTextMap[permission] ?? permission
  }
}
